// Tarayıcı kapatıldığında bile session'ı koruyacak sistem
interface PersistentSession {
  user: any;
  profile: any;
  userFirmas: any[];
  selectedFirma: any;
  permissions: any[];
  timestamp: number;
  expires: number;
}

export const persistentSessionManager = {
  save: (sessionData: Partial<PersistentSession>) => {
    try {
      // Mevcut session'ı al ve birleştir
      const existing = localStorage.getItem('persistent_session');
      const existingData = existing ? JSON.parse(existing) : {};
      
      const data = {
        ...existingData,
        ...sessionData,
        timestamp: Date.now(),
        expires: Date.now() + (7 * 24 * 60 * 60 * 1000) // 7 gün
      };
      localStorage.setItem('persistent_session', JSON.stringify(data));
    } catch (error) {
      console.error('Session kaydetme hatası:', error);
    }
  },

  restore: (): PersistentSession | null => {
    try {
      const saved = localStorage.getItem('persistent_session');
      if (saved) {
        const data = JSON.parse(saved);
        if (data.expires > Date.now()) {
          return data;
        } else {
          localStorage.removeItem('persistent_session');
        }
      }
    } catch (error) {
      console.error('Session geri yükleme hatası:', error);
      localStorage.removeItem('persistent_session');
    }
    return null;
  },

  clear: () => {
    localStorage.removeItem('persistent_session');
  }
};